import React, { useState, useEffect } from "react";
import "./Wishlist.css";
import auth_service from "../../../src/services/auth_service";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
// import toast from "react-hot-toast";
import SkeletonLoading from "../../components/SkeletonLoading";
import { useWishlist } from "../../context/WishlistContext";

const Wishlist = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { wishlistProducts, removeFromWishlist, loadWishlistData, refreshWishlist, wishlistCount } = useWishlist();

  const IMAGE_URL = "https://newpos.spectsgenie.com/";
  let isLoggedIn = false;
  let customerId;

  try {
    const { id } = auth_service.getAccessTokenData();
    customerId = id;
    if (customerId) {
      isLoggedIn = true;
    }
  } catch (error) {
    isLoggedIn = false;
  }

  useEffect(() => {
    setLoading(true);
    if (wishlistProducts && wishlistProducts.length >= 0) {
      setProducts(wishlistProducts);
    }
    setLoading(false);
  }, [wishlistProducts, wishlistCount]);

  // Force reload wishlist data when component mounts
  useEffect(() => {
    const reloadWishlist = async () => {
      setLoading(true);
      try {
        await loadWishlistData();
      } finally {
        setLoading(false);
      }
    };
    reloadWishlist();
  }, []);

  // Handle manual refresh
  const handleRefresh = async () => {
    setLoading(true);
    try {
      await refreshWishlist();
      // toast.success("Wishlist refreshed!", {
      //   duration: 2000,
      //   position: "top-center",
      //   style: {
      //     background: "#10B981",
      //     color: "#fff",
      //   },
      // });
    } catch (error) {
      // toast.error("Failed to refresh wishlist", {
      //   duration: 2000,
      //   position: "top-center",
      //   style: {
      //     background: "#EF4444",
      //     color: "#fff",
      //   },
      // });
    } finally {
      setLoading(false);
    }
  };

  const removeItem = async (product) => {
    if (!product || !product.product_id) {
      return;
    }

    try {
      const result = await removeFromWishlist(product.product_id);
      if (result.success) {
        // toast.success("Item removed from wishlist", {
        //   duration: 3000,
        //   position: "top-center",
        //   style: {
        //     background: "#10B981",
        //     color: "#fff",
        //   },
        // });
        // Reload wishlist data to update the UI
        await loadWishlistData();
      } else {
        // toast.error("Failed to remove item from wishlist", {
        //   duration: 3000,
        //   position: "top-center",
        //   style: {
        //     background: "#EF4444",
        //     color: "#fff",
        //   },
        // });
      }
    } catch (error) {
      console.error("Error removing item:", error);
      // toast.error("Failed to remove item from wishlist", {
      //   duration: 3000,
      //   position: "top-center",
      //   style: {
      //     background: "#EF4444",
      //     color: "#fff",
      //   },
      // });
    }
  };

  // Navigate to product details page
  const handleViewProduct = (item) => {
    const productId = item.product_id;
    const categoryId = item.ca_id;
    
    if (productId && categoryId) {
      navigate(`/product/${productId}/${categoryId}`);
    }
  };

  // Handle card click to navigate to product details
  const handleCardClick = (item) => {
    handleViewProduct(item);
  };



  return (
    <div className="bg-gray-50 min-h-screen pb-10">
      <div className="bg-[#1F509A] text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 mt-2 text-sm">
            <Link to="/" className="hover:text-[#FFD700] transition-colors">Home</Link>
            <span>›</span>
            <span className="text-[#FFD700]">Wishlist</span>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        {loading ? (
          <>
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-2xl font-bold text-[#1F509A]">My Wishlist</h2>
                <p className="text-gray-500 mt-1">Items you've added to your wishlist</p>
              </div>
              <Link to="/" className="text-[#1F509A] hover:underline flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Continue Shopping
              </Link>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <SkeletonLoading type="product" count={8} />
            </div>
          </>
        ) : products.length > 0 ? (
          <>
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-2xl font-bold text-[#1F509A]">My Wishlist ({products.length})</h2>
                <p className="text-gray-500 mt-1">Items you've added to your wishlist</p>
              </div>
              <div className="flex items-center gap-4">
                {/* <button
                  onClick={handleRefresh}
                  className="text-[#1F509A] hover:underline flex items-center gap-1"
                  disabled={loading}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                  {loading ? "Refreshing..." : "Refresh"}
                </button> */}
                <Link to="/" className="text-[#1F509A] hover:underline flex items-center gap-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Continue Shopping
                </Link>
              </div>
            </div>
            
            {/* Login message for non-logged-in users */}
            {/* {!isLoggedIn && (
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-6 mb-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-blue-800 mb-2">Your favorites</h3>
                    <p className="text-blue-700 text-sm mb-3">
                      Sign in to save your favorites plus view your previously liked frames.
                    </p>
                    <Link
                      to="/signin"
                      className="bg-[#1F509A] hover:bg-[#000055] text-white px-6 py-2 rounded-lg font-semibold transition-colors duration-300 inline-flex items-center gap-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                      </svg>
                      Sign In
                    </Link>
                  </div>
                </div>
              </div>
            )} */}
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {products.map((item) => {
                const isContactLens = item.ca_id === 3;
                const productName = isContactLens
                  ? (item.contactlens_name || item.name || item.product_name)
                  : (item.name || item.product_name);
                const productSlug = isContactLens
                  ? (item.contactlens_slug || item.slug)
                  : item.slug;
                const productPrice = isContactLens
                  ? (item.contactlens_sale_price || item.contact_lens_price || item.price)
                  : (item.pr_sprice || item.price);
                // Get image data with proper fallback
                let images = [];
                
                if (isContactLens) {
                  // For contact lenses, try contactlens_images first, then fallback to others
                  if (item.contactlens_images) {
                    images = item.contactlens_images.split(",").map(img => img.trim()).filter(img => img);
                  } else if (item.pr_image_json) {
                    try {
                      images = JSON.parse(item.pr_image_json);
                    } catch (e) {
                      images = item.pr_image_json.split(",").map(img => img.trim()).filter(img => img);
                    }
                  } else if (item.pr_image) {
                    images = item.pr_image.split(",").map(img => img.trim()).filter(img => img);
                  }
                } else {
                  // For regular products, try pr_image_json first
                  if (item.pr_image_json) {
                    try {
                      images = JSON.parse(item.pr_image_json);
                    } catch (e) {
                      images = item.pr_image_json.split(",").map(img => img.trim()).filter(img => img);
                    }
                  } else if (item.pr_image) {
                    images = item.pr_image.split(",").map(img => img.trim()).filter(img => img);
                  }
                }
                
                const displayedImage = images.length > 0
                  ? (images[0].startsWith('http') ? images[0] : `${IMAGE_URL}${images[0]}`)
                  : "https://via.placeholder.com/300x200?text=No+Image";

                return (
                  <motion.div 
                    key={item.product_id || item.id} 
                    className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow duration-300 relative group cursor-pointer"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    onClick={() => handleCardClick(item)}
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={displayedImage}
                        alt={productName || "Product Image"}
                        className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-110"
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/300x200?text=No+Image";
                        }}
                      />
                      <button
                        className="absolute top-3 right-3 bg-white rounded-full p-2 shadow-md hover:bg-red-50 transition-colors duration-300"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeItem(item);
                        }}
                        aria-label="Remove item"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                    
                    <div className="p-4">
                      <h2 className="font-semibold text-[#1F509A] line-clamp-2">{productName}</h2>
                      <p className="text-gray-500 text-sm mb-2">{productSlug}</p>
                      <div className="flex justify-between items-center">
                        <p className="text-xl font-bold text-[#1F509A]">₹{productPrice}</p>
                        <button
                          className="bg-[#1F509A] hover:bg-[#000055] text-white px-3 py-2 rounded-md text-sm font-medium transition-colors duration-300 flex items-center gap-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewProduct(item);
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          View
                        </button>
                      </div>
                    </div>
                    
                    <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-[#1F509A] to-[#000055] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </motion.div>
                );
              })}
            </div>
          </>
        ) : !loading ? (
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col items-center py-20 bg-white rounded-lg shadow-sm p-10 max-w-2xl mx-auto"
          >
            <div className="w-32 h-32 mb-6 text-[#1F509A] opacity-30">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h1 className="font-bold text-2xl mb-2 text-[#1F509A]">
              Your Wishlist is Empty!
            </h1>
            <p className="text-gray-500 text-center max-w-md mb-6">
              Looks like you haven't added any products to your wishlist yet. Browse our collection and add items you love.
            </p>
            <Link
              to="/"
              state={{
                message: "Continue shopping to add items to your Wishlist.",
              }}
              className="inline-block"
            >
              <button className="bg-[#1F509A] text-white px-8 py-3 rounded-md hover:bg-[#000055] transition-colors duration-300 font-medium flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                Start Shopping
              </button>
            </Link>
          </motion.div>
        ) : null}
      </div>


    </div>
  );
};

export default Wishlist;
